import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

export type ReqParams = HttpParams | { [param: string]: string | string[] | number | boolean };
export type ReqHeaders = HttpHeaders | { [header: string]: string | string[] };
export type ResType = 'arraybuffer' | 'blob' | 'json' | 'text';

export type RequestConfig = {
  headers?: ReqHeaders;
  params?: ReqParams;
  responseType?: ResType;
  observe?: string;
  body?: any;
};

export type StorageData<T> = {
  fetchTime: number;
  data: T;
};

export function createReqOptions(config?: RequestConfig) {
  return {
    responseType: config?.responseType as any,
    headers: config?.headers,
    params: config?.params
  };
}

export class CoreApiService {
  private http: HttpClient = inject(HttpClient);

  // cachedItemValidity: number = 15 * 60 * 1000;
  cachedItemValidity = 0;

  get<T = any>(path: string, config?: RequestConfig): Observable<T> {
    return this.http.get<T>(`${environment.baseApiUrl}/${path}`, createReqOptions(config));
  }

  put<T = any>(path: string, requestBody: any, config?: RequestConfig): Observable<T> {
    return this.http.put<T>(`${environment.baseApiUrl}/${path}`, requestBody, createReqOptions(config));
  }

  post<T = any>(path: string, requestBody: any, config?: RequestConfig): Observable<T> {
    return this.http.post<T>(`${environment.baseApiUrl}/${path}`, requestBody, createReqOptions(config));
  }

  patch<T = any>(path: string, requestBody: any, config?: RequestConfig): Observable<T> {
    return this.http.patch<T>(`${environment.baseApiUrl}/${path}`, requestBody, createReqOptions(config));
  }

  delete<T = any>(path: string, config?: RequestConfig): Observable<T> {
    return this.http.delete<T>(`${environment.baseApiUrl}/${path}`, createReqOptions(config));
  }
}
